import { userEmailsCanMarkInviteAsPaid } from 'constants/index'
import { useSelector } from 'react-redux'

import { selectIsInternalAdmin, selectLoggedinUserEmail } from '../accessors'

export const useManagePaymentPermissions = () => {
  const userEmail = useSelector(selectLoggedinUserEmail)
  const isInternalAdmin = useSelector(selectIsInternalAdmin)

  const canManagePaymentStatuses =
    userEmailsCanMarkInviteAsPaid.includes(userEmail) && isInternalAdmin

  return { canManagePaymentStatuses }
}
